/**
 * Unified category/tag color mapping for the entire site.
 * Consolidates all scattered getCategoryColor / getTagColor functions.
 */

const CATEGORY_COLORS: Record<string, string> = {
  // 按摩 & 芳療
  按摩: "bg-green-100 text-green-700",
  芳療: "bg-purple-100 text-purple-700",

  // 健身 & 運動
  健身: "bg-red-100 text-red-700",
  運動: "bg-red-100 text-red-700",

  // 攝影 & 婚禮
  攝影: "bg-rose-100 text-rose-700",
  婚禮: "bg-rose-100 text-rose-700",

  // 旅遊、住宿
  旅遊: "bg-cyan-100 text-cyan-700",
  住宿: "bg-cyan-100 text-cyan-700",

  // 美食 & 餐飲
  美食: "bg-orange-100 text-orange-700",
  餐廳: "bg-orange-100 text-orange-700",
  咖啡: "bg-stone-100 text-stone-700",

  // 美容 & 醫美 & 美業
  醫美: "bg-pink-100 text-pink-700",
  美髮: "bg-pink-100 text-pink-700",
  美容: "bg-pink-100 text-pink-700",
  做臉: "bg-pink-100 text-pink-700",
  美甲: "bg-fuchsia-100 text-fuchsia-700",
  美睫: "bg-fuchsia-100 text-fuchsia-700",
  霧眉: "bg-rose-100 text-rose-700",
  除毛: "bg-rose-100 text-rose-700",
  SPA: "bg-emerald-100 text-emerald-700",
  越式洗髮: "bg-teal-100 text-teal-700",
  采耳: "bg-teal-100 text-teal-700",
  頭皮護理: "bg-teal-100 text-teal-700",
  塔羅: "bg-violet-100 text-violet-700",
  星盤: "bg-violet-100 text-violet-700",
  命理: "bg-violet-100 text-violet-700",
  馬雅圖騰: "bg-violet-100 text-violet-700",
  彩妝造型: "bg-pink-100 text-pink-700",
  暖罐: "bg-amber-100 text-amber-700",
  岩盤浴: "bg-amber-100 text-amber-700",
  瑜珈: "bg-green-100 text-green-700",
  形象管理: "bg-slate-100 text-slate-700",
  攝影: "bg-rose-100 text-rose-700",
  情侶約會: "bg-red-100 text-red-700",
  光療舒壓: "bg-stone-100 text-stone-700",
  色彩鑑定: "bg-rose-100 text-rose-700",
  穿搭: "bg-orange-100 text-orange-700",

  // 娛樂 & 密室
  密室: "bg-purple-100 text-purple-700",
  遊戲: "bg-purple-100 text-purple-700",
  手作: "bg-purple-100 text-purple-700",
  DIY: "bg-purple-100 text-purple-700",
  約會: "bg-purple-100 text-purple-700",

  // 水上活動
  潛水: "bg-blue-100 text-blue-700",
  SUP: "bg-blue-100 text-blue-700",
  水上活動: "bg-blue-100 text-blue-700",

  // 酒吧 & 夜生活
  酒吧: "bg-indigo-100 text-indigo-700",
  夜生活: "bg-indigo-100 text-indigo-700",
};

const DEFAULT_COLOR = "bg-slate-100 text-slate-700";

/**
 * Get the Tailwind color classes for a given category or tag name.
 */
export function getCategoryColorClass(name: string): string {
  return CATEGORY_COLORS[name] || DEFAULT_COLOR;
}

/**
 * Alias for tag colors (same mapping as categories).
 */
export const getTagColorClass = getCategoryColorClass;